/**
 * Subscribe Popup — 邮箱订阅弹窗表单逻辑
 * 依赖:
 *   - window.__MC__CONFIG__ (apiUrl / headers / cookieName)
 *   - window.DsmDialog (open / close) — 由 dsm-components.js 提供
 *   - dsm-modal 容器 — 由 sections/qualify-popup.liquid 渲染
 *   - <root data-boa-subscribe-root> 容器 (在 subscribe_modal block 中渲染)
 *
 * 流程:
 *   1. 用户在 dsm-modal 内点击 Subscribe 按钮
 *   2. 校验邮箱 (空 / 正则)
 *   3. 按钮进入 is-loading 状态,文字变为 "Submitting..."
 *   4. POST /api/station/user/subscribe
 *   5. 若 enable_customer_tag → GET /api/station/activity/collectEmail 打 tag
 *   6. 切换为成功态 → 延时 auto_close_ms → DsmDialog.close(dialogId)
 */
;(function () {
  'use strict'

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

  function getConfig() {
    return window.__MC__CONFIG__ || {}
  }

  function normalizeResult(json) {
    if (!json || typeof json !== 'object') return {}
    return json.result || json.data || json
  }

  function getErrorMessage(json, fallback) {
    return (json && (json.message || json.msg)) || fallback
  }

  function isFailure(response, json) {
    if (!response.ok) return true
    if (json && json.code !== undefined) {
      var code = String(json.code)
      return ['0', '200'].indexOf(code) === -1
    }
    return false
  }

  /*
async function subscribeRequest(path, body) {
  var config = getConfig()
  var response = await fetch((config.apiUrl || '') + path, {
    method: 'POST',
    headers: Object.assign(
      { 'Content-Type': 'application/json' },
      config.headers || {}
    ),
    credentials: 'include',
    body: JSON.stringify(body || {})
  })
  var json = await response.json().catch(function () { return {} })
  if (isFailure(response, json)) {
    throw new Error(getErrorMessage(json, 'Unable to complete your request. Please try again.'))
  }
  return json
}
*/

  async function assignCustomerTag(root, email, tagValue, sceneId, submitUrl) {
    var tag = (tagValue || '').trim()
    var config = getConfig()
    var sourceKey = root.dataset.sourceKey || ''
    var params = [
      'email=' + encodeURIComponent(email),
      'scene=' + encodeURIComponent(sceneId || '12'),
      'reSubmittable=0',
      'subscribe=1',
    ]
    if (sourceKey) {
      params.push('sourceKey=' + encodeURIComponent(sourceKey))
    }
    if (tag) {
      params.push('tagValue=' + encodeURIComponent(tag))
    }
    if (submitUrl) {
      params.push('submitUrl=' + encodeURIComponent(submitUrl))
    }
    var response = await fetch(
      (config.apiUrl || '') + '/api/station/activity/collectEmail?' + params.join('&'),
      {
        method: 'GET',
        headers: Object.assign({}, config.headers || {}),
        credentials: 'include'
      }
    ).catch(function () {
      // 网络/请求失败 — 参考 components.js catch 分支
      throw new Error(root.dataset.errorInvalid || 'Request failed, please try again.')
    })
    if (!response.ok) {
      throw new Error(root.dataset.errorInvalid || 'Request failed, please try again.')
    }
    var json = await response.json().catch(function () { return {} })
    var code = json && json.code !== undefined ? String(json.code) : ''
    if (code === '10006171') {
      // 重复提交 — 参考 components.js 10006171 分支
      throw new Error(root.dataset.errorDuplicate || 'This email has already been subscribed.')
    }
    if (code && code !== '0' && code !== '200') {
      throw new Error(getErrorMessage(json, root.dataset.errorGeneric || 'Something went wrong, please try again later.'))
    }
  }

  function setButtonLoading(button, loading) {
    if (!button) return
    button.classList.toggle('is-loading', loading)
    button.setAttribute('aria-busy', loading ? 'true' : 'false')
    if (loading) {
      var label = button.querySelector('.dsm-btn__label')
      if (label) {
        if (!button.dataset.originalLabel) button.dataset.originalLabel = label.textContent
        label.textContent = 'Submitting...'
      }
    } else if (button.dataset.originalLabel) {
      var label2 = button.querySelector('.dsm-btn__label')
      if (label2) label2.textContent = button.dataset.originalLabel
    }
  }

  function setInputError(input, errorEl, message) {
    if (!input || !errorEl) return
    if (message) {
      input.classList.add('is-invalid')
      errorEl.textContent = message
      errorEl.hidden = false
    } else {
      input.classList.remove('is-invalid')
      errorEl.textContent = ''
      errorEl.hidden = true
    }
  }

  function showState(root, stateName) {
    var states = root.querySelectorAll('[data-boa-subscribe-state]')
    for (var i = 0; i < states.length; i += 1) {
      states[i].hidden = states[i].dataset.boaSubscribeState !== stateName
    }
  }

  function init(root) {
    if (!root || root.dataset.boaSubscribeReady === 'true') return
    root.dataset.boaSubscribeReady = 'true'

    var dialogId = root.dataset.dialogId
    var form = root.querySelector('[data-boa-subscribe-form]')
    var input = root.querySelector('[data-boa-subscribe-email]')
    var submit = root.querySelector('[data-boa-subscribe-submit]')
    var errorEl = root.querySelector('[data-boa-subscribe-error]')
    if (!form || !input || !submit || !errorEl) return

    var autoCloseMs = parseInt(root.dataset.autoCloseMs, 10) || 3000
    var tagEnabled = root.dataset.tagEnabled === 'true'
    var tagValue = root.dataset.tagValue || ''
    var tagScene = root.dataset.tagScene || '12'
    var sourceKey = root.dataset.sourceKey || ''
    var autoCloseTimer = null

    function clearError() { setInputError(input, errorEl, '') }
    function showError(message) { setInputError(input, errorEl, message || '') }

    input.addEventListener('input', function () {
      if (input.classList.contains('is-invalid')) clearError()
    })

    function openModal() {
      if (window.DsmDialog && typeof window.DsmDialog.open === 'function') {
        window.DsmDialog.open(dialogId)
      } else {
        var ovl = document.getElementById(dialogId + '-overlay')
        if (ovl) {
          ovl.removeAttribute('hidden')
          ovl.classList.add('is-open')
        }
      }
      showState(root, 'form')
      clearError()
      input.value = ''
      // focus after animation frame so dsm-modal can settle
      requestAnimationFrame(function () {
        try { input.focus({ preventScroll: true }) } catch (e) { input.focus() }
      })
    }

    function closeAndReset() {
      if (autoCloseTimer) { clearTimeout(autoCloseTimer); autoCloseTimer = null }
      if (window.DsmDialog && typeof window.DsmDialog.close === 'function') {
        window.DsmDialog.close(dialogId)
      } else {
        var ovl = document.getElementById(dialogId + '-overlay')
        if (ovl) {
          ovl.setAttribute('hidden', '')
          ovl.classList.remove('is-open')
        }
      }
      showState(root, 'form')
      clearError()
      input.value = ''
    }

    function switchToSuccess() {
      showState(root, 'success')
      /* 顶部 DsmToast 提示已停用,只保留弹窗内的 success section
      if (window.DsmToast && typeof window.DsmToast.show === 'function') {
        var toastId = window.DsmToast.show({
          message: root.dataset.successTitle || 'Thank you for subscribing!',
          tone: 'success',
          placement: 'top-center'
        })
        var toast = document.getElementById('dsm-toast-' + toastId)
        if (toast) toast.classList.add('yg-brand-day-toast--viewport-center')
      }
      */
      autoCloseTimer = setTimeout(closeAndReset, autoCloseMs)
    }

    form.addEventListener('submit', async function (event) {
      event.preventDefault()
      if (submit.classList.contains('is-loading')) return
      clearError()

      var email = (input.value || '').trim()
      if (!email) {
        showError(root.dataset.errorEmpty || 'Email is required')
        try { input.focus({ preventScroll: true }) } catch (e) { input.focus() }
        return
      }
      if (!EMAIL_RE.test(email)) {
        showError(root.dataset.errorInvalid || 'Please enter a valid email address')
        try { input.focus({ preventScroll: true }) } catch (e) { input.focus() }
        return
      }

      setButtonLoading(submit, true)
      try {
        /* /api/station/user/subscribe 接口暂停使用,只走 /api/station/activity/collectEmail
        await subscribeRequest('/api/station/user/subscribe', {
          email: email,
          sourceKey: sourceKey
        })
        */
        if (tagEnabled) {
          await assignCustomerTag(root, email, tagValue, tagScene, window.location.origin + window.location.pathname)
        }
        switchToSuccess()
      } catch (error) {
        showError(error.message || root.dataset.errorGeneric || 'Something went wrong, please try again later.')
      } finally {
        setButtonLoading(submit, false)
      }
    })

    // Expose helpers on the root for the trigger button (close + reset)
    root.boaSubscribe = {
      open: openModal,
      close: closeAndReset
    }
  }

  function initAll(container) {
    ;(container || document).querySelectorAll('[data-boa-subscribe-root]').forEach(init)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document) })
  } else {
    initAll(document)
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target)
  })
})()
